import {
  OPEN_SWEET_ALERT,
  sweetAlert,
  getSweetAlertInterceptor
} from "../libs/sweet-alert"

const sweetAlertMiddleware = () => next => action => {
  switch (action.type) {
    case OPEN_SWEET_ALERT: {
      // Embedded pages forward alerts to the host instead of opening in-frame.
      const interceptor = getSweetAlertInterceptor()
      if (interceptor) return interceptor(action)
      return sweetAlert(action.preset, action.option, action.promise)
    }
    default:
  }
  next(action)
  return null
}

export default sweetAlertMiddleware
